export default {
  intro: {
    first: "è un",
    second: "dalle",
    competenze: "competenze",
    third: "eterogenee che da oltre dieci anni integra",
    tecnologia: "tecnologia",
    design: "design e sviluppo web",
    fourth: "per sostenere la crescita dei suoi",
    clienti: "clienti",
  },
  nav: {
    chi: {
      title: "Chi",
      desc:
        "Integriamo tecnologia e marketing per sostenere la crescita dei nostri clienti.",
      slug: "chi",
      children: {
        competenze: {
          title: "Competenze",
          slug: "competenze",
        },
        vision: {
          title: "Vision",
          slug: "la-nostra-visione",
        },
        metodo: {
          title: "Metodo",
          slug: "metodo",
        },
        persone: {
          title: "Persone",
          slug: "persone",
        },
      },
    },
    come: {
      title: "Servizi",
      desc:
        "Coders, progettisti, ingegneri e creativi; le competenze e i servizi Dinamo.",
      slug: "come",
      children: {
        marketing: {
          title: "Marketing & Comunicazione",
          slug: "marketing",
        },
        design: {
          title: "Design & Sviluppo",
          slug: "design-sviluppo",
        },
        building: {
          title: "Building & Industrial Automation",
          slug: "building-industrial-automation",
        },
      },
    },
    cosa: {
      title: "Progetti",
      desc:
        "Una selezione di progetti che abbiamo realizzato per i nostri clienti.",
      slug: "cosa",
      children: {
        portfolio: {
          title: "Portfolio",
          slug: "cosa",
        },
        casi: {
          title: "Casi studio",
          slug: "cosa",
        },
      },
    },
    contatti: {
      aperto: "in questo momento è aperto.",
      chiuso: "in questo momento è chiuso.",
      mail: "Puoi contattarci inviando una",
      whatsapp: "o un messaggio su",
      telefono: "Se preferisci puoi",
      telefonare: "telefonare",
      o: "o",
      venire: "venire a trovarci",
      persona: "di persona.",
    },
  },
  filters: {
    "show-case": "Casi Studio",
    research: "Ricerca",
    client: "Clienti",
  },
  message: {
    read: "Leggi",
  },
};
